export default __webpack_public_path__ + "terminal.png";